// Mirrors backend/constants/interview_scheduling.py - keep option lists in sync.

export const WORK_AUTH_STATUSES = [
  { value: "JAPANESE_CITIZEN", labelKey: "workAuth.JAPANESE_CITIZEN" },
  { value: "PERMANENT_RESIDENT", labelKey: "workAuth.PERMANENT_RESIDENT" },
  { value: "LONG_TERM_RESIDENT", labelKey: "workAuth.LONG_TERM_RESIDENT" },
  { value: "SPOUSE_OR_CHILD_OF_JAPANESE_NATIONAL", labelKey: "workAuth.SPOUSE_OR_CHILD_OF_JAPANESE_NATIONAL" },
  { value: "SPOUSE_OR_CHILD_OF_PERMANENT_RESIDENT", labelKey: "workAuth.SPOUSE_OR_CHILD_OF_PERMANENT_RESIDENT" },
  { value: "WORK_AUTHORIZED_RESIDENCE_STATUS", labelKey: "workAuth.WORK_AUTHORIZED_RESIDENCE_STATUS" },
  { value: "STUDENT_WITH_PERMISSION_TO_WORK", labelKey: "workAuth.STUDENT_WITH_PERMISSION_TO_WORK" },
  { value: "DEPENDENT_WITH_PERMISSION_TO_WORK", labelKey: "workAuth.DEPENDENT_WITH_PERMISSION_TO_WORK" },
  { value: "MILITARY_SOFA_AUTHORIZED", labelKey: "workAuth.MILITARY_SOFA_AUTHORIZED" },
  { value: "WORKING_HOLIDAY", labelKey: "workAuth.WORKING_HOLIDAY" },
  { value: "OTHER", labelKey: "workAuth.OTHER" },
  { value: "NOT_SURE", labelKey: "workAuth.NOT_SURE" },
];

export const SHIFT_INTERESTS = [
  { value: "OPENING", labelKey: "shiftInterest.OPENING" },
  { value: "MORNING", labelKey: "shiftInterest.MORNING" },
  { value: "AFTERNOON", labelKey: "shiftInterest.AFTERNOON" },
  { value: "EVENING", labelKey: "shiftInterest.EVENING" },
  { value: "CLOSING", labelKey: "shiftInterest.CLOSING" },
  { value: "WEEKDAYS", labelKey: "shiftInterest.WEEKDAYS" },
  { value: "WEEKENDS", labelKey: "shiftInterest.WEEKENDS" },
  { value: "PUBLIC_HOLIDAYS", labelKey: "shiftInterest.PUBLIC_HOLIDAYS" },
  { value: "FULL_TIME", labelKey: "shiftInterest.FULL_TIME" },
  { value: "PART_TIME", labelKey: "shiftInterest.PART_TIME" },
  { value: "FLEXIBLE", labelKey: "shiftInterest.FLEXIBLE" },
];

export const SHIFTS_PER_WEEK_OPTIONS = ["1", "2", "3", "4", "5_PLUS", "UNSURE"];
export const YES_NO_UNSURE = ["YES", "NO", "UNSURE"];

export const WEEKLY_DAYS = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];
export const WEEKLY_PERIODS = ["opening", "morning", "afternoon", "evening", "closing", "unavailable"];

export const EMPTY_WEEKLY_AVAILABILITY = WEEKLY_DAYS.reduce((acc, day) => {
  acc[day] = { opening: false, morning: false, afternoon: false, evening: false, closing: false, unavailable: false };
  return acc;
}, {});

export const INTERVIEW_BOOKING_STATUSES = [
  "HELD", "PENDING_CONFIRMATION", "CONFIRMED", "RESCHEDULE_REQUESTED", "RESCHEDULED",
  "CANCELLED_BY_APPLICANT", "CANCELLED_BY_MANAGEMENT", "COMPLETED", "NO_SHOW", "EXPIRED",
];
